<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" class="pa-3">
                <vendedor-crud />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import VendedorCrud from "./VendedorCrud/VendedorCrud.vue";
export default {
    name: "VendedorManagementPage",
    components: { VendedorCrud }
}
</script>
